import React from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Project.css";

export default function Project(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const data = [
    {
      id: 1,
      image: "nokri.gif",
      title: "Naukri Clone",
      description:
        " Users can find relevant jobs as per experience and knowledge. This project includes features like applying for job, connect to recruters, promo code, sign in, sign up.",
      demo: "https://naukriclone98.vercel.app/",
      code: "https://github.com/dipakshinde-art/Naukri-Clone",
      stack: ["react.svg", "chkra.jpg", "redux.svg", "css.svg", "js.svg"],
    },
    
    {
      id: 3,
      image: "cd.gif",
      title: "Code Editor",
      description:"A code editor is a software application that provides a text editing interface specifically designed for writing and editing code in any language",
      demo: "https://cd-editor.netlify.app/",
      code: "https://github.com/dipakshinde-art/code-ediitor.git",
      stack: ["react.svg", "redux.svg", "mongo.svg", "node.svg","express.svg"],
    },
    {
      id: 2,
      image: "track.gif",
      title: "Tracking Time Clone",
      description:
        "It is a clone about Time Management and how can You distribute task Between day. it consist workflow of activity you can do in a day  and plan according to that",
      demo: "https://timetrcak.netlify.app/",
      code: "https://github.com/dipakshinde-art/Tracking-Time",
      stack: ["react.svg", "redux.svg", "mongo.svg", "node.svg"],
    },
  ];

  return (
    <div>
      <ScreenHeading
        title={"Projects"}
        subHeading={"Look at My Work"}
      ></ScreenHeading>
      <div className="projects-container fade-in" id={props.id || ""}>
        {data.map((e) => (
          <div key={e.id} className="project-div">
            <div className="main-image">
              <img src={e.image} alt="" />
            </div>
            <h5>
              <b>{e.title}</b>
            </h5>
            <p>{e.description}</p>
            <div className="stack-img">
              {e.stack.map((ele, i) => (
                <img key={i} src={ele} />
              ))}
            </div>
            <div className="button-link">
              <div>
                <a href={e.demo} target="_blank">
                  <button>
                    {/* <i className="fas fa-link">
                                        </i> */}
                    Demo
                  </button>
                </a>
              </div>
              <div>
                <a href={e.code} target="_blank">
                  <button>
                    {/* <i className="fab fa-github">
                                        </i> */}
                    Code
                  </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
